import { Box, Drawer, Toolbar } from '@mui/material';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Can from '../auth/can';

export default function MenuLeft(props) {
	const links = [
		{ label: 'Profile', link: '/profile', permission: 'user.view' },
		// {label: 'School', link: '/school', permission: 'school.view'},
		{ label: 'Students', link: '/students', permission: 'student.list' },
		// {label: 'Subjects', link: '/subjects', permission: 'subject.list'},
		{ label: 'Courses', link: '/courses', permission: 'course.list' },
		{ label: 'Terms', link: '/terms', permission: 'term.list' },
		{ label: 'Holidays & Breaks', link: '/holidays', permission: 'holiday.list' },
		{ label: 'Catchup', link: '/catchup', permission: 'catchup.view' },
		{ label: 'Upcoming', link: '/upcoming', permission: 'upcoming.view' },
		{ label: 'Daily', link: '/calendar/daily', permission: 'daily.view' },
		{ label: '3-Day', link: '/calendar/3-day', permission: 'threeDay.view' },
		{ label: 'Weekly', link: '/calendar/weekly', permission: 'weekly.view' },
		{ label: 'Monthly', link: '/calendar/monthly', permission: 'monthly.view' },
		// {label: 'Todos', link: '/todos', permission: 'todo.list'},
	]

	return (
		<Box>
			<Drawer open={props.open} onClose={() => props.setOpen(false)}>
				<Toolbar />
				<Box sx={{ minWidth: 150 }}>
					<List>
						{links.map((link) =>
							<Can key={link.label} permission={link.permission}>
								<ListItemButton href={link.link}>
									<ListItemText>{link.label}</ListItemText>
								</ListItemButton>
							</Can>
						)}
					</List>
				</Box>
			</Drawer>
		</Box>
	);
}